import type { PropsWithChildren } from 'react'
import Box from '@mui/material/Box'
import Sider from '@app/components/Sider'

export const Layout = ({ children }: PropsWithChildren) => (
  <Box sx={{ display: 'flex', bgcolor: 'background.default', width: '100vw' }}>
    <Sider />
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', width: '1px' }}>
      <Box
        component="main"
        sx={{
          flex: 1,
          position: 'relative',
          pt: { xs: 1, md: 2, lg: 3 },
          pb: { xs: 1, md: 2, lg: 3 },
          pr: { xs: 1, md: 2, lg: 3 },
          bgcolor: 'background.default',
        }}
      >
        {children}
      </Box>
    </Box>
  </Box>
)
